import type React from 'react';

import type { ManageAccessStep } from '@/types/manage-access.types';
import StepManageAccessOwners from '@/components/organism/ManageAccess/steps/StepManageAccessOwners';
import StepManageAccessMembers from '@/components/organism/ManageAccess/steps/StepManageAccessMembers';
import StepManageAccessExternal from '@/components/organism/ManageAccess/steps/StepManageAccessExternal';
import StepManageAccessReview from '@/components/organism/ManageAccess/steps/StepManageAccessReview';

export function getManageAccessStepConfig(step: ManageAccessStep): {
  component: React.ComponentType<{ onClose: () => void }>;
} {
  if (step === 'Owners') return { component: StepManageAccessOwners };
  if (step === 'Members') return { component: StepManageAccessMembers };
  if (step === 'External') return { component: StepManageAccessExternal };
  return { component: StepManageAccessReview };
}
